import { PostData } from "../File";

export function getPostBody(file: File, postData: PostData): FormData {
  const formData = new FormData();
  Object.entries(postData.fields).forEach(([key, value]) => {
    formData.append(key, value);
  });
  formData.append("Content-Type", file.type);
  formData.append("File", file);
  return formData;
}
